import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { http } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    http.get("/auth/me").then((r) => setUser(r.data || false)).catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    setUser(data);
    return data;
  }, []);
  const register = useCallback(async (name, email, phone, password) => {
    const { data } = await http.post("/auth/register", { name, email, phone, password });
    setUser(data);
    return data;
  }, []);
  const logout = useCallback(async () => {
    await http.post("/auth/logout").catch(() => null);
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, setUser, login, register, logout }), [user, login, register, logout]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
